import type React from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { DescriptionType } from '../../Description.h'

import { LabelWarning, LabelWithBorderLeft } from 'atoms/Label/Templates'
import { TextBoxMaxLine2Font4xl } from 'atoms/TextBox/Templates'
import { LabelGroupTemplate3MaxLabels6 } from 'blocks/LabelGroup/Templates'
import { MultiColumnsRowGap } from 'blocks/MultiColumns'
import {
  LabelsGroupDescription3Line,
  PayPerViewTimer,
} from 'blocks/MultiColumns/Templates'
import {
  DescriptionAlignItems,
  DescriptionDirection,
  DescriptionJustifyContent,
} from '../../Description.h'
import {
  LiveEventDescriptionColumnSC,
  LiveEventDescriptionSC,
  TitleWrapper,
} from '../../Description.styled'

export interface ILiveEventUpcomingDescription extends DescriptionType {
  title: ITextBoxProps['title']
  daysTitleTimer?: ITextBoxProps['daysTitle']
  hoursTitleTimer?: ITextBoxProps['hoursTitle']
  minutesTitleTimer?: ITextBoxProps['minutesTitle']
  secondsTitleTimer?: ITextBoxProps['secondsTitle']
  rowGap?: MultiColumnsRowGap
  children?: React.ReactNode
  titleTimer?: string
  completionDate?: string
  formattedStartTime?: string
  live?: boolean
  liveTitle?: string
  onTimerCompleted?: () => void
  onClickMore?: (args: any) => void
  quality?: string
  dolbyAtmos?: boolean
}

export const LiveEventUpcomingDescription = ({
  labels,
  text,
  stars,
  directors,
  title,
  rowGap = MultiColumnsRowGap.INDENT_60,
  children,
  titleTimer,
  daysTitleTimer,
  hoursTitleTimer,
  minutesTitleTimer,
  secondsTitleTimer,
  completionDate,
  formattedStartTime,
  live,
  liveTitle,
  onTimerCompleted,
  onClickMore,
  quality,
  dolbyAtmos,
  ...rest
}: ILiveEventUpcomingDescription) => {
  return (
    <LiveEventDescriptionSC
      {...rest}
      width={100}
      direction={DescriptionDirection.Row}
      alignItems={DescriptionAlignItems.FlexEnd}
      justifyContent={DescriptionJustifyContent.SpaceBetween}
    >
      <LiveEventDescriptionColumnSC>
        <TitleWrapper>
          {live && liveTitle ? (
            <LabelWarning title={liveTitle} />
          ) : (
            formattedStartTime && (
              <LabelWithBorderLeft title={formattedStartTime} />
            )
          )}
          {(labels || quality || dolbyAtmos) && (
            <LabelGroupTemplate3MaxLabels6
              list={labels || []}
              quality={quality}
              dolbyAtmos={dolbyAtmos}
            />
          )}
        </TitleWrapper>

        <TitleWrapper>
          <TextBoxMaxLine2Font4xl title={title} />
        </TitleWrapper>
        <LabelsGroupDescription3Line
          more={rest.more}
          episodePopup={rest.episodePopup}
          titlePopup={rest.titlePopup}
          labelsPopup={rest.labelsPopup}
          listPopup={rest.listPopup}
          titleButton={rest.titleButton}
          directorsPopup={rest.directorsPopup}
          starsPopup={rest.starsPopup}
          fullInformation={rest.fullInformation}
          textDirectors={directors}
          textStars={stars}
          text={text}
          width={rest.width || 100}
          popupWidth={rest.popupWidth}
          rowGap={rowGap}
          onClickMore={onClickMore}
        >
          {children}
        </LabelsGroupDescription3Line>
      </LiveEventDescriptionColumnSC>
      <PayPerViewTimer
        title={titleTimer}
        completionDate={completionDate!}
        onTimerCompleted={onTimerCompleted}
        daysTitle={daysTitleTimer}
        hoursTitle={hoursTitleTimer}
        minutesTitle={minutesTitleTimer}
        secondsTitle={secondsTitleTimer}
      />
    </LiveEventDescriptionSC>
  )
}
